import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState, useEffect, useRef } from "react";
import {  IconButton, Modal, Box, Dialog, DialogActions, DialogContent, TextField, DialogTitle, Grid, Card, CardContent, FormControlLabel, Checkbox } from '@mui/material';
import Table from 'react-bootstrap/Table';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import "layouts/style.css"
import { ToastContainer,toast } from "react-toastify";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Select from "react-select";
import { Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { fetchAllCustomer } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { getAllUsers } from "assets/globalAPI/apiGlobal";
import { fetchRoleMaster } from "assets/globalAPI/apiGlobal";
import { createUser } from "assets/globalAPI/apiGlobal";
import { showLoginHistory } from "assets/globalAPI/apiGlobal";

const LoginHistory = ()=>{
const toastId= useRef(null)
    const navigate= useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [isActive,setIsActive]= useState(false)
    const [loginDetails,setLoginDetails]= useState([])
    const [currentPage,setCurrentPage]= useState(1);
    const [totalPages,setTotalPages]= useState(1);
    const [selectedUser,setSelectedUser]= useState(null);
    const [roles,setRoles]= useState([]);
    const [memberOf,setMemberOf]= useState("")
    const [memberOfName,setMemberOfName]= useState("")
    const [userId,setUserId]= useState("")
    const [newName,setNewName]= useState("");
    const [newEmail,setNewEmail]= useState("");
    const [newPassword, setNewPassword]= useState("");
    const [newDesignation,setNewDesignation]= useState("");
    const [newDepartment,setNewDepartment]= useState("");
    const [newMemberOf,setNewMemberOf]= useState("");
    const [newRole,setNewRole]=useState("");
    const [newRoleName,setNewRoleName]= useState("");
    const [newAdmin,setNewAdmin]=useState(0);
    const [edit,setEdit]=useState(false);

   useEffect(()=>{
            fetchLoginHistory()
        },[currentPage])

    const fetchLoginHistory= async()=>{
        setIsActive(true)
        const body={
            "page":currentPage,
        }

        try{
            const response= await showLoginHistory(body)
            const res= response.data;
            console.log("Login history response",res)
            if(res.status){
                setIsActive(false)
                setLoginDetails(res.data)
                setTotalPages(res.totalPages)
            }else{
                setIsActive(false)
                if(!toast.isActive(toastId.current)){
                                toastId.current= toast.error("Could Not fetch Login history",{
                                  className:"small-toast"
                                })
                              }
            }
        }catch(error){
            console.log("Error fetching login history",error)
            if(!toast.isActive(toastId.current)){
                toastId.current= toast.error(error.message,{
                  className:"small-toast"
                })
              }
               if(error.response?.status==403){
                            if(!toast.isActive(toastId.current)){
                              toastId.current= toast.error("Your Session has expired",{
                                className:"small-toast"
                              })
                            }
                            setTimeout(()=>{
                              navigate("/")
                              localStorage.clear();
                            },2000)
                            return;
                          }
        }

    } 

    const handlePageChange=(p)=>{
        setCurrentPage(p)
        
      }

    const formatLoginTime = (timestamp) => {
        if(timestamp==null || timestamp==undefined){
            return;
        }
        const date = new Date(timestamp.replace(" ", "T")); // replace space with T for ISO compliance
        return date.toLocaleString("en-US", {
          dateStyle: "medium",
          timeStyle: "short",
        });
      };


    return(
        <DashboardLayout>
            <DashboardNavbar/>
            <ToastContainer/>
            <SimpleBackdrop openLoader={isActive}/>
            <div style={{overflowX: "auto", marginTop: "20px"}}>
             <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                        <thead>
                        <tr style={{color : "white",backgroundColor: "#3498db"}}>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >USER ID</th>
                        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >NAME</th>
                            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >DESIGNATION</th>
                            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >LOGIN TIME</th>
                            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >LOGOUT TIME</th>

                        </tr>
                        </thead>
                        <tbody>
                            {loginDetails.map((user,index)=>(
                                <tr key={index}>
                                     <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{user.userid}</td>
                              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{user.name}</td>
                              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{user.designation}</td>
                              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{formatLoginTime(user.login_at)}</td>
                              <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{formatLoginTime(user.logoutat)}</td>
                                </tr>
                            ))}
                        </tbody>
                        </Table></div>
                         {/* <Pagination className="mt-3">
                                        <Pagination.Prev 
                                          disabled={currentPage === 1} 
                                          onClick={() => handlePageChange(currentPage - 1)}
                                        />
                                        {[...Array(totalPages).keys()].map((page) => (
                                          <Pagination.Item 
                                            key={page + 1} 
                                            active={page + 1 === currentPage} 
                                            onClick={() => handlePageChange(page + 1)}
                                          >
                                            {page + 1}
                                          </Pagination.Item>
                                        ))}
                                        <Pagination.Next 
                                          disabled={currentPage === totalPages} 
                                          onClick={() => handlePageChange(currentPage + 1)}
                                        />
                                      </Pagination> */}

                                       <Pagination className="mt-3">
                                        <Pagination.Prev
                                          disabled={currentPage === 1}
                                          onClick={() => handlePageChange(currentPage - 1)}
                                          style={{
                                            color: "danger",
                                            borderRadius: "5px",
                                          }}
                                        />
                                      
                                        {/* Always show first page */}
                                        <Pagination.Item
                                          active={currentPage === 1}
                                          onClick={() => handlePageChange(1)}
                                          style={{
                                            color: currentPage === 1 ? "#fff" : "danger",
                                            backgroundColor: currentPage === 1 ? "danger" : "transparent",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          1
                                        </Pagination.Item>
                                      
                                        {/* Left dots */}
                                        {currentPage > 3 && <Pagination.Ellipsis disabled />}
                                      
                                        {/* Middle page numbers */}
                                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                                          .filter(
                                            (page) =>
                                              page !== 1 &&
                                              page !== totalPages &&
                                              Math.abs(currentPage - page) <= 1
                                          )
                                          .map((page) => (
                                            <Pagination.Item
                                              key={page}
                                              active={page === currentPage}
                                              onClick={() => handlePageChange(page)}
                                              style={{
                                                color: page === currentPage ? "#fff" : "danger",
                                                backgroundColor: page === currentPage ? "danger" : "transparent",
                                                borderRadius: "5px",
                                              }}
                                            >
                                              {page}
                                            </Pagination.Item>
                                          ))}
                                      
                                        {/* Right dots */}
                                        {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}
                                      
                                        {/* Always show last page */}
                                        {totalPages > 1 && (
                                          <Pagination.Item
                                            active={currentPage === totalPages}
                                            onClick={() => handlePageChange(totalPages)}
                                            style={{
                                              color: currentPage === totalPages ? "#fff" : "danger",
                                              backgroundColor:
                                                currentPage === totalPages ? "danger" : "transparent",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {totalPages}
                                          </Pagination.Item>
                                        )}
                                      
                                        <Pagination.Next
                                          disabled={currentPage === totalPages}
                                          onClick={() => handlePageChange(currentPage + 1)}
                                          style={{
                                            color: "danger",
                                            borderRadius: "5px",
                                          }}
                                        />
                                      </Pagination>
        </DashboardLayout>
    )

}

export default LoginHistory;    